import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,

} from "../../service/casino";
import { useLocation, useParams } from "react-router-dom";
import {
  getOddsByRunner,
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import toast from "react-hot-toast";

import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function FastDragonTiger() {
  const { id: GAME_ID } = useParams();
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const generic = GAME_ID == "UNI_FAST_LUCKY_7";
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };

  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
  
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    // Add interval for time condition check
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  return (
    <app-dragon-tiger _nghost-ng-c3335278031="">
      <app-video-player _ngcontent-ng-c3335278031="" _nghost-ng-c595356512="">
        <div
          style={{ overflowY: "scroll" }}
          _ngcontent-ng-c595356512=""
          className="videoPlayer"
        >
          <video
            _ngcontent-ng-c595356512=""
            id="remoteVideo"
            width="100%"
            height="100%"
            autoPlay=""
            playsInline=""
            muted=""
            style={{ backgroundColor: "black", backgroundSize: "contain" }}
          />

          <div _ngcontent-ng-c595356512="" className="video-overlay">
            <div _ngcontent-ng-c595356512="">
              <div _ngcontent-ng-c595356512="" className="round-id text-white">
                RID: {odds?.roundId}
              </div>

              {odds?.playerCards?.map((player) => (
                <div _ngcontent-ng-c595356512="">
                  <h3 _ngcontent-ng-c595356512="" className="text-white">
                    {player?.forPerson}
                  </h3>
                  <div _ngcontent-ng-c595356512="">
                    {player?.cards?.map((card) => (
                      <img
                        _ngcontent-ng-c595356512=""
                        src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {showWinnerOverlay && (
            <div _ngcontent-ng-c595356512="" className="winnerOverlay">
              <div
                _ngcontent-ng-c595356512=""
                className="mini-result-new active"
              >
                <span _ngcontent-ng-c595356512="">
                  {" "}
                  {odds?.roundWinner} win{" "}
                </span>
                {/**/}
              </div>
              <span
                _ngcontent-ng-c595356512=""
                style={{ position: "absolute" }}
              >
                <canvas
                  _ngcontent-ng-c595356512=""
                  width="100vw"
                  height="100vh"
                />
              </span>
              {/**/}
            </div>
          )}

          <div _ngcontent-ng-c595356512="" className="timer-overlay">
            <GenericCasinoTimer time={odds?.seconds} status={odds?.status} />
          </div>
        </div>

        <div
          _ngcontent-ng-c595356512=""
          id="rulesModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabelaexampleModalLabela"
          aria-hidden="true"
          className="modal fade"
        >
          <div _ngcontent-ng-c595356512="" className="modal-dialog rules-wrap">
            <div
              _ngcontent-ng-c595356512=""
              role="document"
              id="rulesList___BV_modal_content_"
              tabIndex={-1}
              className="modal-content rules-content"
            >
              <header
                _ngcontent-ng-c595356512=""
                id="rulesList___BV_modal_header_"
                className="rules-wrap"
              >
                <a _ngcontent-ng-c595356512="">
                  <h3
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_title_"
                    data-bs-toggle="modal"
                    data-bs-target="#rulesModal"
                    className="modal-title"
                  >
                    {" "}
                    Rules
                  </h3>
                </a>
                <button
                  _ngcontent-ng-c595356512=""
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="close"
                >
                  ×
                </button>
              </header>
              <div
                _ngcontent-ng-c595356512=""
                id="rulesList___BV_modal_body_"
                className="modal-body"
              >
                <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
              </div>
              <div _ngcontent-ng-c595356512="">
                <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                  <li _ngcontent-ng-c595356512="">
                    <a
                      _ngcontent-ng-c595356512=""
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="btnok"
                    >
                      OK
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </app-video-player>
      <div _ngcontent-ng-c3335278031="" className="dragon-tiger-20">
        <div _ngcontent-ng-c3335278031="" className="light-bg container-fluid">
          {generic ? (
            <div _ngcontent-ng-c3395235639="" className="row row5">
              <div
                _ngcontent-ng-c3395235639=""
                className={`col-5 euBox firstbox ${
                  odds?.status == "SUSPEND" && "suspended"
                }`}
              >
                <button
                
                  _ngcontent-ng-c3395235639=""
                  className="btn-theme mt-1"
                >
                  {" "}
                  LOW CARD ( A to 6 )
                </button>
                <p
                  _ngcontent-ng-c3395235639=""
                  className="d-block mb-0 text-center"
                >
                  <b _ngcontent-ng-c3395235639="">
                    {getOddsByRunner(odds, "LOW CARD ( A to 6 )")}
                  </b>
                </p>
                <p
                  _ngcontent-ng-c3395235639=""
                  className="mt-1 mb-0 text-danger text-center h-18"
                >
                  {getUniversalCasinoPlExposureByRunner(
                    exposure,
                    "LOW CARD ( A to 6 )"
                  )}
                </p>
              </div>
              <div
               
                _ngcontent-ng-c3395235639=""
                className="col-2 text-center lucky7card"
              >
                <p
                  _ngcontent-ng-c3395235639=""
                  className="d-block mb-0 text-center"
                >
                  {getUniversalCasinoPlExposureByRunner(exposure, "LUCKY CARD")}
                </p>
                <div
                  _ngcontent-ng-c3395235639=""
                  className={odds?.status == "SUSPEND" && "suspended"}
                >
                  <img
                    _ngcontent-ng-c3395235639=""
                    src="https://casino.queenexch.com/assets/lucky7_cards/7.png"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div
               
                _ngcontent-ng-c3395235639=""
                className={`col-5 euBox secondBox ${
                  odds?.status == "SUSPEND" && "suspended"
                }`}
              >
                <button _ngcontent-ng-c3395235639="" className="btn-theme mt-1">
                  {" "}
                  HIGH CARD ( 8 to K )
                </button>
                <p
                  _ngcontent-ng-c3395235639=""
                  className="d-block mb-0 text-center h-18"
                >
                  <b _ngcontent-ng-c3395235639="">
                    {getOddsByRunner(odds, "HIGH CARD ( 8 to K )")}
                  </b>
                </p>
                <p
                  _ngcontent-ng-c3395235639=""
                  className="mt-1 mb-0 text-danger text-center h-18"
                >
                  {getUniversalCasinoPlExposureByRunner(
                    exposure,
                    "HIGH CARD ( 8 to K )"
                  )}
                </p>
              </div>
            </div>
          ) : (
            <div _ngcontent-ng-c3335278031="" className="row row5">
              {odds?.markets?.map((item) =>
                item?.oddDetailsDTO?.map((odd) => (
                  <div
                 
                    _ngcontent-ng-c3335278031=""
                    className={
                      odd?.runnerName == "DRAGON"
                        ? "col-5"
                        : odd?.runnerName == "TIE"
                        ? "col-2 pe-0 ps-0"
                        : "col-5"
                    }
                  >
                    <p
                      _ngcontent-ng-c3335278031=""
                      className="d-block mb-0 text-center"
                    >
                      <b _ngcontent-ng-c3335278031="">{odd?.back1}</b>
                    </p>
                    <button
                      _ngcontent-ng-c3335278031=""
                      className={`btn-theme mt-1 ${odd?.runnerName} ${
                        odds?.status == "SUSPEND" && "suspended"
                      }`}
                    >
                      {odd?.runnerName}
                    </button>
                    <p
                      _ngcontent-ng-c3335278031=""
                      className="mt-1 mb-0 text-center"
                    >
                      {getUniversalCasinoPlExposureByRunner(
                        exposure,
                        odd?.runnerName
                      )}
                    </p>
                  </div>
                ))
              )}
            </div>
          )}

          <div _ngcontent-ng-c3335278031="" className="row row5">
            <div _ngcontent-ng-c3335278031="" className="col-12">
              <p
                _ngcontent-ng-c3335278031=""
                className="mt-1 mb-0 text-end min-max"
              >
                Min:100 Max:100000
              </p>
            </div>
          </div>
        </div>
      </div>
      <section
        _ngcontent-ng-c3335278031=""
        id="functionZone"
        className="function_zone mt-2"
      >
        <ul _ngcontent-ng-c3335278031="" id="chips" className="chips">
          {[
            { img: "chips1", amount: 100, label: "100" },
            { img: "chips1", amount: 200, label: "200" },
            { img: "chips1", amount: 300, label: "300" },
            { img: "chips1", amount: 400, label: "400" },
            { img: "chips1", amount: 500, label: "500" },
            { img: "chips1", amount: 600, label: "600" },
            { img: "chips1", amount: 800, label: "800" },
            { img: "chips1k", amount: 1000, label: "1k" },
          ].map((item) => (
            <li
             
              _ngcontent-ng-c1910803830=""
              className={`chips_1 ${
                placeBetPayload?.amount === item.amount ? "now" : ""
              }`}
            >
              <img
                _ngcontent-ng-c1910803830=""
                src={`https://casino.queenexch.com/assets/chips/${item?.img}.svg`}
              />

              <p _ngcontent-ng-c1910803830="">{item.label} </p>
              <span _ngcontent-ng-c1910803830="" className="ring">
                ring
              </span>
            </li>
          ))}
        </ul>
      </section>
      <GetUniversalLastTenResult lastResult={lastResult} />
    </app-dragon-tiger>
  );
}
